/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { tracingService, trackingService } from 'services';

import { ValidationStatus } from './helpers';

export const trackFeelExpressionEval = (state, element) => {
  if (state.status !== ValidationStatus.LOADING) {
    const result =
      state.status === ValidationStatus.SUCCESS
        ? 'success'
        : state.status === ValidationStatus.WARNING
          ? 'warning'
          : 'error';

    const warningMessages =
      state.status === ValidationStatus.WARNING && 'warnings' in state && state.warnings
        ? state.warnings.map((warning) => warning.type)
        : null;

    try {
      trackingService.trackFeelExpressionEvaluation({
        elementType: element?.type || undefined,
        fieldName: element?.di?.bpmnElement?.name || undefined,
        result,
        warnings: warningMessages
      });
    } catch (ex) {
      tracingService.traceError(ex, `trackingService.trackFeelExpressionEvaluation failed.`);
    }
  }
};
